import { Box, styled, Typography } from "@material-ui/core";
import {
  EPOCUS_AMBER,
  EPOCUS_AMBER_BG,
  EPOCUS_AMBER_BORDER,
  EPOCUS_TEXT_PRIMARY,
  rem,
} from "../epocus-palette";
import { SIGNING_GATE_LABELS, type SigningGateItem } from "./signing-gate";

const ChecklistRoot = styled(Box)({
  backgroundColor: EPOCUS_AMBER_BG,
  border: `1px solid ${EPOCUS_AMBER_BORDER}`,
  borderRadius: 10,
  padding: "10px 14px",
});

const Heading = styled(Typography)({
  fontSize: rem(13),
  fontWeight: 700,
  color: EPOCUS_AMBER,
});

const Item = styled("li")({
  fontSize: rem(13),
  color: EPOCUS_TEXT_PRIMARY,
});

export const SigningChecklist: FC<{ missing: readonly SigningGateItem[] }> = ({
  missing,
}) =>
  missing.length === 0 ? null : (
    <ChecklistRoot role="status" aria-label="Needed before signing">
      <Heading>Needed before you can sign</Heading>
      <ul style={{ margin: "4px 0 0", paddingLeft: 18 }}>
        {missing.map((item) => (
          <Item key={item}>{SIGNING_GATE_LABELS[item]}</Item>
        ))}
      </ul>
    </ChecklistRoot>
  );
